<template>
  <div class="page">
  
    <accordion :multiple="true" :activeIndex="[0, 1]" >
      <accordion-tab>
        <template #header>
          <span>Stai per modificare {{ data_.podIds.length }} {{ (data_.podIds.length != 1)? 'pods': 'pod' }}</span>
        </template>

        <div class="formgrid grid">

          <div class="field col-12 md:col-4">
            <label for="cod_type_tensione">Tipologia Tensione</label>
            <dropdown 
              id="cod_type_tensione"
              v-model="data_.item.cod_type_tensione" 
              :options="tipiTensione" 
              optionLabel="name" 
              optionValue="id" 
              placeholder="Seleziona..." 
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="cod_type_misuratore">Tipologia Misuratore</label>
            <dropdown 
              id="cod_type_misuratore" 
              v-model="data_.item.cod_type_misuratore" 
              :options="tipiMisuratore" 
              optionLabel="name" 
              optionValue="id" 
              placeholder="Seleziona..." 
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="cod_type_uso">Tipologia Uso</label>
            <dropdown 
              id="cod_type_uso" 
              v-model="data_.item.cod_type_uso" 
              :options="tipiUso" 
              optionLabel="name" 
              optionValue="id" 
              placeholder="Seleziona..." 
              class="inputfield w-full"
            />
          </div>

          <div class="field col-12 md:col-4">
            <label for="cod_type_residente">Tipologia Residente</label>
            <dropdown 
              id="cod_type_residente" 
              v-model="data_.item.cod_type_residente" 
              :options="tipiResidente" 
              optionLabel="name" 
              optionValue="id" 
              placeholder="Seleziona..." 
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="cod_type_stima">Tipologia Stima</label>
            <dropdown 
              id="cod_type_stima" 
              v-model="data_.item.cod_type_stima" 
              :options="tipiStima" 
              optionLabel="name" 
              optionValue="id" 
              placeholder="Seleziona..." 
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="fatturazione_solo_reale">Fatturazione solo reale</label>
            <dropdown 
              id="fatturazione_solo_reale" 
              v-model="data_.item.fatturazione_solo_reale" 
              :options="booleanSelect" 
              optionLabel="label" 
              optionValue="value" 
              placeholder="Seleziona..." 
              class="inputfield w-full"
            />
          </div>

          <div class="field col-12 md:col-4">
            <label for="distributori">Distributori</label>
            <dropdown 
              dataKey="id"
              :filter="true"
              id="distributori"
              v-model="data_.item.cod_distributore" 
              :options="distributori" 
              optionLabel="name" 
              optionValue="id" 
              placeholder="Seleziona..." 
              class="inputfield w-full"
            />
          </div>

        </div>

        <div class="p-d-flex p-p-3 justify-content-end">
          <prime-button 
            label="Modifica pods" 
            icon="pi pi-file-o" 
            class="mb-auto"
            :disabled="( sended )" 
            @click="onUpdateButton($event)" 
          />
        </div>

        <div v-if="sended" class="p-d-flex">
          <span v-if="success">La modifica dei pods ha avuto successo</span>
          <span v-else>C&lsquo;è stato un errore</span>
        </div> 

      </accordion-tab> 

      <accordion-tab v-if="success">
        <template #header>
          <span>{{ (pods.length != 1)? 'Sono stati modificati': "E' stato modificato" }} {{pods.length }} {{ (pods.length != 1)? 'pods': 'pod' }}</span>
        </template>

        <div class="formgrid grid">
          <div 
            v-for="pod in pods " :key="pod.id"
            class="field col-12 md:col-2"
          >
            
            <router-link :to="`/ask/pods/${pod.id}/dettagli`"
              custom
              v-slot="{ href }"
            >
              <prime-button 
                icon="pi pi-file-o"
                :label="pod.code"
                class="mb-auto" 
                @click="navigateToTab(href)" 
              />
            </router-link>

          </div>
        </div>

      </accordion-tab>
    </accordion>

  </div>
</template>

<script>
import Service from '@/services/ask-management/pods-service'

import UtilityService from '@/services/ask-management/utility-service'

import PrimeButton from 'primevue/button'

export default {
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  
  components: {
    PrimeButton
  },

  data() {
    return {
      page:{
        name: 'pods-modifica-massiva',
      },

      sended: false,
      success: false,

      data_: {
        item: {
          cod_type_tensione: -1,
          cod_type_residente: -1,
          cod_type_uso: -1,
          cod_type_stima: -1,
          cod_type_misuratore: -1,
          cod_distributore: -1,
          fatturazione_solo_reale: -1,
          
        },

        podIds: this.data,
      },

      booleanSelect: [
          {label: 'Nessuno', value: -1},
          {label: 'No', value: 0},
          {label: 'Si', value: 1},
        ],

      tipiTensione: [],
      tipiMisuratore: [],
      tipiUso: [],
      tipiResidente: [],
      tipiStima: [],
      distributori: [],

      pods: [],
    }
  },

  created(){
    this.service = new Service(this.$http, this.$eventBus)

    this.utilityService = new UtilityService(this.$http, this.$eventBus)
    this.getTipiStima()
    this.getTipiTensione()
    this.getTipiResidente()
    this.getTipiUso()
    this.getTipiMisuratore()
    this.getDistributoriEnergia()
    
  },


  methods:{

    onCancelButton(){
      this._reset()

      this.$eventBus.emit('dialog-return-cancel-button', {})
    },

    ////

    onUpdateButton(/** event **/){
      const ids = [...this.data_.podIds]

      const data = Object.entries({...this.data_.item})
      .map(([key, value])=>{
        if( key.startsWith('cod_') ){
          if(value == -1){
            value = null
          }
        }

        if( typeof(value) == 'string' ){
          value.trim()
          if( value == '' ){
            value = null
          }
        }

        return [key, value]
      })
      .reduce((obj, [key, value]) => {
        return {
          ...obj,
          [key]: value
        };
      }, {})

      if(data.fatturazione_solo_reale == -1){
        data.fatturazione_solo_reale = null
      }

      const len = Object.values(data)
      .filter( (value) => value !== null )
      .length

      if(len != 0){
     
        this.service.updateMassivoPods({
          data,
          filters: {
            'pod.ids': ids
          },
        }).then((res) => {
          this.sended = true

          this.pods = res.pods
          this.success = res.success
        })
        
      }else{
        alert('Nulla da modificare')
      }
    },

    ////

    _reset(){
      this.sended = false
      this.success = false

      this.data_.item.cod_type_tensione = -1
      this.data_.item.cod_type_residente = -1
      this.data_.item.cod_type_uso = -1
      this.data_.item.cod_type_stima = -1
      this.data_.item.cod_type_misuratore = -1
      this.data_.item.fatturazione_solo_reale = -1

      this.data_.podIds = [] 

      this.tipiTensione = []
      this.tipiMisuratore = [] 
      this.tipiUso = []
      this.tipiResidente = []
      this.tipiStima = []
      this.distributori = []

      this.pods = []
    },

    navigateToTab(href){
      window.open(href, '_blank')
    },

    getTipiTensione(){
      this.utilityService.getTipiTensione().then((res) => {
        res.items.unshift({
          id: -1,
          name: 'Nessuno'
        })

        this.tipiTensione = res.items
      })
    },

    getTipiMisuratore(){
      this.utilityService.getTipiMisuratore().then((res) => {
        res.items.unshift({
          id: -1,
          name: 'Nessuno'
        })

        this.tipiMisuratore = res.items
      })
    },

    getTipiUso(){
      this.utilityService.getTipiUso().then((res) => {
        res.items.unshift({
          id: -1,
          name: 'Nessuno'
        })

        this.tipiUso = res.items
      })
    },

    getTipiResidente(){
      this.utilityService.getTipiResidente().then((res) => {
        res.items.unshift({
          id: -1,
          name: 'Nessuno'
        })

        this.tipiResidente = res.items
      })
    },

    getTipiStima(){
      this.utilityService.getTipiStima().then((res) => {
        res.items.unshift({
          id: -1,
          name: 'Nessuno'
        })

        this.tipiStima = res.items
      })
    },

    getDistributoriEnergia(){
      this.utilityService.getDistributoriEnergia().then((res) => {
        res.items.unshift({
          id: -1,
          name: 'Nessuno'
        })

        this.distributori = res.items
      })
    },

  },

  computed:{
    
  },
}
</script>

<style scoped>
  
</style>
